import { defineComponent as _defineComponent } from 'vue'
import { ArticleV1 } from '@ilteducation/content-registry-types';
import { ref } from 'vue';
import customProvider, { Params } from '@/data-provider/customProvider';
import { useExcelDownload } from '@/comp/use-excel-download';


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadArticleStats',
  setup(__props) {

const { exportExcel } = useExcelDownload();

const loading = ref(false);

async function fetchArticles(): Promise<ArticleV1[]> {
  const params: Params = {
    filter: {},
    sort: [],
    pagination: {
      perPage: 100,
      page: 1,
    },
    include: undefined,
  };

  const getData = () => customProvider().getList('articles', params);
  const articles: ArticleV1[] = [];
  let done = false;
  do {
    // eslint-disable-next-line no-await-in-loop
    const { data, total } = await getData();
    articles.push(...(data as ArticleV1[]));
    done = articles.length >= (total ?? 0);
    params.pagination.page! += 1;
  } while (!done);
  return articles;
}

async function createExcel() {
  try {
    loading.value = true;
    const articles = await fetchArticles();

    const convertedArticles = articles.map((article) => ({
      ...article,
      hasAudio: Object.getOwnPropertyNames(article.audio ?? {}).length > 0,
      wordCount: article.content?.wordCount || 0,
      hasExercises: !!article.properties?.additionalContent,
      audioLanguages: Object.keys(article.audio ?? {}).join(', '),
      mediaSource: [article.mediaSource ?? []].flat().join(', '),
      lastUpdated: article.lastUpdatedAt ? new Date(article.lastUpdatedAt).toLocaleDateString() : '',
    }));

    exportExcel(
      [
        { label: 'ID', field: 'id' },
        { label: 'Headline', field: 'headline' },
        { label: 'Author', field: 'author' },
        { label: 'Publisher', field: 'publisher' },
        { label: 'Media Source', field: 'mediaSource' },
        { label: 'Word Count', field: 'wordCount' },
        { label: 'Is Published', field: 'isPublished' },
        { label: 'Has Audio', field: 'hasAudio' },
        { label: 'Audio Languages', field: 'audioLanguages' },
        { label: 'Has Exercises', field: 'hasExercises' },
        { label: 'Market', field: 'realm' },
        { label: 'Language', field: 'content.language' },
        { label: 'Last Updated', field: 'lastUpdated' },
      ],
      convertedArticles,
      'articles-export',
    );
  } finally {
    loading.value = false;
  }
}

return { __sfc: true,exportExcel, loading, fetchArticles, createExcel }
}

})